// src/utils/clearCache.js

export const clearCache = async () => {
  try {
    // ✅ Clear localStorage
    localStorage.clear();

    // ✅ Clear sessionStorage
    sessionStorage.clear();

    // ✅ Unregister all service workers (if PWA or CRA default setup)
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let registration of registrations) {
        await registration.unregister();
      }
    }

    // ✅ Clear browser cache storage (for fetch / assets)
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    console.log('✅ All caches cleared successfully!');
  } catch (error) {
    console.error('❌ Error clearing cache:', error);
  }
};
